// modules/tenant-builder/steps/CustomizationStep.tsx

import React from 'react';
import { Tenant } from '../../../core/types';

interface Props {
  data: Partial<Tenant>;
  onChange: (updates: Partial<Tenant>) => void;
}

export const CustomizationStep: React.FC<Props> = ({ data, onChange }) => {
  const branding = data.branding || {} as any;

  const updateBranding = (key: string, value: any) => {
    onChange({
      branding: {
        ...(data.branding || {} as any),
        [key]: value
      }
    });
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-6">
        {/* Cores */}
        <div className="col-span-2">
          <h3 className="font-semibold text-lg mb-4">Paleta de Cores</h3>
          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Cor Primária
              </label>
              <div className="flex items-center gap-3">
                <input
                  type="color"
                  value={branding.primaryColor || '#1e40af'}
                  onChange={(e) => updateBranding('primaryColor', e.target.value)}
                  className="h-12 w-20 rounded cursor-pointer"
                />
                <input
                  type="text"
                  value={branding.primaryColor || '#1e40af'}
                  onChange={(e) => updateBranding('primaryColor', e.target.value)}
                  className="flex-1 px-3 py-2 border rounded text-gray-900"
                  placeholder="#1e40af"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Cor Secundária
              </label>
              <div className="flex items-center gap-3">
                <input
                  type="color"
                  value={branding.secondaryColor || '#dc2626'}
                  onChange={(e) => updateBranding('secondaryColor', e.target.value)}
                  className="h-12 w-20 rounded cursor-pointer"
                />
                <input
                  type="text"
                  value={branding.secondaryColor || '#dc2626'}
                  onChange={(e) => updateBranding('secondaryColor', e.target.value)}
                  className="flex-1 px-3 py-2 border rounded text-gray-900"
                  placeholder="#dc2626"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Cor de Destaque
              </label>
              <div className="flex items-center gap-3">
                <input
                  type="color"
                  value={branding.accentColor || '#059669'}
                  onChange={(e) => updateBranding('accentColor', e.target.value)}
                  className="h-12 w-20 rounded cursor-pointer"
                />
                <input
                  type="text"
                  value={branding.accentColor || '#059669'}
                  onChange={(e) => updateBranding('accentColor', e.target.value)}
                  className="flex-1 px-3 py-2 border rounded text-gray-900"
                  placeholder="#059669"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Fonte */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Fonte Principal
          </label>
          <select
            value={branding.fontFamily || 'Inter'}
            onChange={(e) => updateBranding('fontFamily', e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-900"
          >
            <option value="Inter">Inter (Moderna)</option>
            <option value="Roboto">Roboto (Clássica)</option>
            <option value="Poppins">Poppins (Elegante)</option>
            <option value="Montserrat">Montserrat (Bold)</option>
            <option value="Open Sans">Open Sans (Limpa)</option>
          </select>
        </div>

        {/* Tema */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Tema
          </label>
          <select
            value={branding.theme || 'light'}
            onChange={(e) => updateBranding('theme', e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-900"
          >
            <option value="light">☀️ Claro</option>
            <option value="dark">🌙 Escuro</option>
            <option value="auto">🔄 Automático</option>
          </select>
        </div>

        {/* Logo */}
        <div className="col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Logo (URL da imagem)
          </label>
          <input
            type="url"
            value={branding.logoUrl || ''}
            onChange={(e) => updateBranding('logoUrl', e.target.value)}
            placeholder="https://..."
            className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-900"
          />
          <p className="text-xs text-gray-500 mt-1">
            Você poderá fazer upload de logo depois no painel
          </p>
        </div>
      </div>

      {/* Preview */}
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
        <h4 className="font-semibold mb-3">Pré-visualização</h4>
        <div 
          className="rounded-lg p-6 text-white"
          style={{ backgroundColor: branding.primaryColor || '#1e40af', fontFamily: branding.fontFamily || 'Inter' }}
        >
          <h2 className="text-2xl font-bold mb-2">{data.businessName || 'Sua Pousada'}</h2>
          <p className="opacity-90">{data.slogan || 'Seu slogan aparecerá aqui'}</p>
          <button 
            className="mt-4 px-6 py-2 rounded-lg font-medium"
            style={{ backgroundColor: branding.accentColor || '#059669' }}
          >
            Reservar Agora
          </button>
        </div>
      </div>
    </div>
  );
};
